import { UserType } from "shared/types/enum";

export const hasRole = (roles: string[] | undefined, role: UserType) =>
  !!roles?.includes(role);

export const isSystemAdmin = (roles?: string[]) =>
  hasRole(roles, UserType.SysAdmin);

export const isManager = (roles?: string[]) => hasRole(roles, UserType.Manager);
